import React from 'react'
import Centered from 'shared/ui/Centered'
import MdxContent from '../ui/MdxContent'

// In gatsby-config.js, some folders that have MDX files (like the blog)
// have special layouts, this is for MDX files that don't have a
// special layout

function DefaultMarkdownLayout({ children, pageContext, location }) {
  return (
    <Centered>
      <MdxContent children={children} location={location} pageContext={pageContext} />
    </Centered>
  )
}

export default DefaultMarkdownLayout
